jQuery(document).ready(function($) {

  $('.o-header__sidenav').on('expand', function() {
    $(this).addClass('o-header__sidenav--open');
    $(this).find('.m-page-nav__item:first-child a').focus();

    const controlledBy = $(this).attr('data-controlledby');
    const $controller  = $('#'+controlledBy);

    $controller.attr('aria-expanded', 'true');
    $('body').css('overflow', 'hidden');
  });


  $('.o-header__sidenav').on('unexpand', function() {
    $(this).removeClass('o-header__sidenav--open');

    const controlledBy = $(this).attr('data-controlledby');
    const $controller  = $('#'+controlledBy);

    $controller.attr('aria-expanded', 'false');
    $('body').removeAttr('style');
  });


  $('.o-header__hamburger').click(function() {
    const ariaExpanded = $(this).attr('aria-expanded');
    const $headerItems = $('.o-header__sidenav');

    if ( ariaExpanded === 'true' ) {
      $headerItems.trigger('unexpand');
    } else {
      $headerItems.trigger('expand');
    }
  });

  $('.o-header__sidenav-button').click(function() {
    const $headerItems = $('.o-header__sidenav');
    $headerItems.trigger('unexpand');
  });

});